import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[adjustFontSize]'
})
export class AdjustFontSizeDirective implements OnChanges {
  @Input('adjustFontSize') text: string;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.adjustFontSize();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.text && !changes.text.firstChange) {
      this.adjustFontSize();
    }
  }

  adjustFontSize(): void {
    const element = this.elementRef.nativeElement;
    const containerWidth = 150; // Update the container width as needed
    let textWidth = this.getTextWidth(element);
  
    if (textWidth > containerWidth) {
      let fontSize = 11; // Starting font size
      const minFontSize = 9; // Minimum font size
      const step = 1; // Font size adjustment step
  
      while (textWidth > containerWidth && fontSize > minFontSize) {
        fontSize -= step;
        element.style.fontSize = `${fontSize}px`;
        element.style.top = `14px`;  
        element.style.left = `19px`;
        textWidth = this.getTextWidth(element);
      }
    } else {
      element.style.fontSize = '11px'; // Reset font size when the text fits within the container
    }
  
    if (this.text && this.text === this.text.toUpperCase()) {
      element.style.top = '15px'; // Add style for capital letters
      element.style.left = '19px'; // Add style for capital letters
    } else {
      // element.style.top = 'initial'; // Reset style if not capital letters
    }
  }
  
  // adjustFontSize(): void {
  //   const element = this.elementRef.nativeElement;
  //   const containerWidth = 150; // Update the container width as needed
  //   let textWidth = this.getTextWidth(element);
  //   if (textWidth > containerWidth) {
  //     let fontSize = 11; // Starting font size
  //     const step = 1; // Font size adjustment step

  //     while (textWidth > containerWidth && fontSize > 0) {
  //       fontSize -= step;
  //       element.style.fontSize = `${fontSize}px`;
  //       textWidth = this.getTextWidth(element);
  //     }
  //   } else {
  //     element.style.fontSize = '11px'; // Reset font size when the text fits within the container
  //   }

    
  //   if (this.text && this.text === this.text.toUpperCase()) {
  //     element.style.top = '19px'; // Add style for capital letters
  //     element.style.left = '19px'; // Add style for capital letters
  //   } else {
  //     //element.style.top = 'initial'; // Reset style if not capital letters
  //   }
  // }

  private getTextWidth(element: HTMLElement): number {
    const tempElement = document.createElement('span');
    tempElement.style.position = 'absolute';
    tempElement.style.visibility = 'hidden';
    tempElement.style.whiteSpace = 'nowrap';
    tempElement.style.fontSize = getComputedStyle(element).fontSize;
    tempElement.textContent = this.text;
    document.body.appendChild(tempElement);
    const width = tempElement.getBoundingClientRect().width;
    document.body.removeChild(tempElement);
    return width;
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/adjust-font-size.directive.ts